import { InjectionToken } from '@angular/core';

import { CommonDialogConfig, DialogConfig } from './types';

export const DIALOG_DATA = new InjectionToken<unknown>('dialogData');

export const DIALOG_CONFIG = new InjectionToken<DialogConfig>('dialogConfig');

export const COMMON_DIALOG_CONFIG = new InjectionToken<CommonDialogConfig>(
  'commonDialogConfig',
);
